import ConnectionViewContainer from './containers/ConnectionViewContainer'

export default ConnectionViewContainer
